import { default as React } from 'react';
import * as Styled from './InfoCard.styles';
export default function InfoCardHeader({ children, className, headerProps, }) {
    return (React.createElement(Styled.Header, { ...headerProps, className: `InfoCard--header ${className}` }, children));
}
